import { httpClient } from "../httpClient";

/** GET /admin/dashboard/overview */
export function getDashboardOverview() {
  return httpClient.get("/admin/dashboard/overview");
}
